/* global ga */

import { Controller } from 'stimulus';

const MAX_TRIES = 5;
const RETRY_INTERVAL = 2000;

class AnalyticsClientId extends Controller {
  connect() {
    this.tries = 0;
    this.fetchClientId();
  }

  fetchClientId() {
    if (this.tries >= MAX_TRIES) {
      return;
    }

    AnalyticsClientId.isGaDefined()
      .then(AnalyticsClientId.fetchClientIdFromGa)
      .then(this.outputClientId.bind(this))
      .catch(() => {
        this.incrementTries();
        this.retryFetchClientId();
      });
  }

  static isGaDefined() {
    return Promise[typeof ga === 'undefined' ? 'reject' : 'resolve']();
  }

  static fetchClientIdFromGa() {
    return new Promise((resolve, reject) => {
      ga(() => {
        const t = ga.getAll();

        if (!t || !t.length) {
          reject();
          return;
        }

        resolve(t[0].get('clientId'));
      });
    });
  }

  outputClientId(clientId) {
    this.element.value = clientId;
  }

  retryFetchClientId() {
    return setTimeout(this.fetchClientId.bind(this), RETRY_INTERVAL);
  }

  incrementTries() {
    this.tries += 1;
  }
}

AnalyticsClientId.targets = [
  //
];

export default AnalyticsClientId;
